import type { ComponentProps, ReactNode } from "react"
import { cn } from "cn"

/**
 * Figma-Component-Set „Input" (node 2117:3055) bündelt Label-Zeile, Feld und
 * Helfertext in einem Frame — analog zu `Select` hier bewusst NICHT als
 * Props auf `Input` nachgebaut. Für Label/Description/Error das generische
 * `Field`-Kit verwenden (siehe `input.stories.tsx` und „V2/Guides/Formulare").
 */
export type InputProps = Omit<ComponentProps<"input">, "suffix"> & {
  /** Figma „Suffix" (z. B. Einheit wie „Min."). */
  suffix?: ReactNode
  showSuffix?: boolean
}

function Input({
  className,
  suffix,
  showSuffix = false,
  disabled,
  ...props
}: InputProps) {
  return (
    <div
      data-slot="input-wrapper"
      className={cn(
        "flex h-9 w-full items-center gap-2 rounded-full border-2 border-neutrals-v2-200 bg-backgrounds-primary py-2 pr-3 pl-4 text-sm leading-5 transition-colors has-[[data-slot=input]:disabled]:cursor-not-allowed has-[[data-slot=input]:focus]:border-brand-blue-100 has-[[data-slot=input][aria-invalid=true]]:border-error-red-200",
        className
      )}
    >
      <input
        data-slot="input"
        disabled={disabled}
        className="peer min-w-0 flex-1 bg-transparent text-labels-primary outline-none placeholder:text-labels-secondary disabled:cursor-not-allowed disabled:text-labels-tertiary"
        {...props}
      />
      {showSuffix && suffix && (
        <span className="shrink-0 text-labels-secondary peer-focus:text-labels-primary peer-disabled:text-labels-tertiary">
          {suffix}
        </span>
      )}
    </div>
  )
}
Input.displayName = "Input"

export { Input }
